import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import { matchPath } from 'react-router';
import { withRouter } from 'react-router-dom';
import { Player, BigPlayButton } from 'video-react';
import { API_URL } from '../QRQinectAPI';

class Share extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.Video = props.Video;
        let maxVideoHeight = window.innerHeight / 2.3;
        this.state.videoHeight = maxVideoHeight;
        this.state.maxVideoHeight = maxVideoHeight;
        this.state.videoWidth = '100%';
        this.state.maxVideoWidth = '100%';
        this.state.videoLoaded = false;
    }
    componentDidMount() {
        // calculate when the video will expire
        let creationDate = new Date(this.state.Video.CreationDate);
        let expirationDate = new Date(
            creationDate.getFullYear(),
            creationDate.getMonth(),
            creationDate.getDate() + 60,
            creationDate.getHours(),
            creationDate.getMinutes(),
            creationDate.getSeconds());
        let expiresIn = Math.floor((Date.UTC(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate()) - Date.now()) / (1000 * 60 * 60 * 24));
        this.setState({ expiresIn: expiresIn, expirationDate: expirationDate });

        this.refs.player.subscribeToStateChange(this.handlePlayerStateChange.bind(this));
        // get the width of the video container so we know what our actual max width is.
        // max height will be in this.state.
        let elWidth = (ReactDOM.findDOMNode(this.refs.videoContainer).getBoundingClientRect().width);
        this.setState({ maxVideoWidth: elWidth });

        // let's try and set a CallToAction function on the window.
        if (!window.TrackClickedLink) {
            window.QRGUID = this.props.QRCode.GUID;
            window.TrackClickedLink = function(linkID) {
                // redirect browser to api.qrqinect.com/api/v1/link?LinkID=&QRGUID=
                let Url = API_URL + 'api/v1/link?LinkID=' + linkID + '&QRGUID=' + window.QRGUID;
                fetch(Url);
                return true;
            }
        }
    }
    handlePlayerStateChange(state, prevState) {
        // copy player state to this component's state
        if (!this.state.videoLoaded && state.videoHeight) {
            this.setState({ videoLoaded: true });
            let newWidth;
            let newHeight;
            // determine the appropriate width and height for the video
            if (state.videoHeight > state.videoWidth) {
                // vertical video, set videoHeight to maxHeight, set videoWidth to maxHeight * aspectRatio
                newHeight = this.state.maxVideoHeight;
                newWidth = ((state.videoWidth / state.videoHeight) * newHeight) + 10; // +10 to compensate for left/right padding

            } else {
                // horizontal video, maxWidth, adjust height
                newWidth = this.state.maxVideoWidth;
                newHeight = ((state.videoHeight / state.videoWidth) * newWidth) + 10; // +10 to compensate for bottom padding
                if (newHeight > this.state.maxVideoHeight) {
                    this.setState({ maxVideoHeight: newHeight });
                }
            }
            this.setState({ videoHeight: newHeight, videoWidth: newWidth });
        }
    }
    DownloadVideo() {
        this.props.history.push('download');
    }
    /**
     * Override the styles from the index so that this page always shows the correct background
     */
    renderCSS() {
        if(!this.props.objectSettings) {
            return null;
        }
        let obj = this.props.objectSettings;
        return (
            <style dangerouslySetInnerHTML={{
                __html: `
        body {
          color: ${obj.TextColor};
          font-family: '${obj.Font}';
        }
        body:before {
          background-image: unset;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #FFFFFF;
        }
        .button {
          color: ${obj.ButtonTextColor};
          background: ${obj.ButtonColor};
        }
        .primaryTextColor {
          color: ${obj.TextColor};
        }
        .buttonBackgroundColor {
          background: ${obj.ButtonColor};
        }
        .logoImage {
          content: url(${obj.LogoPath});
          width: unset;
          margin: 0 auto;
          height: 30px;
        }
        .CircularProgressbar-path {
          stroke: ${obj.ButtonColor};
          fill: ${obj.ButtonColor};
        }
        .CircularProgressbar-text {
          stroke: transparent;
          fill: ${obj.TextColor};
        }
        .slick-dots li.slick-active button {
          background: ${obj.ButtonColor};
        }
        .navbar {
          color: ${obj.ButtonTextColor};
          //background: ${obj.ButtonColor};
          background: white;
        }
        .site-title h1 {
          color: ${obj.ButtonTextColor};
        }
        .secondaryColor {
          color: ${obj.ButtonColor};
        }
        .container .top {
          background-image: url(${obj.BackgroundPath});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-color: ${obj.BackgroundColor};
        }        
      `}} />
        );
    }

    // renderCSS() {
    //     return (
    //         <style dangerouslySetInnerHTML={{
    //             __html: `

    //         body:before {
    //           background-image: unset;
    //         }
    //       `}} />
    //     );
    // }
    renderMiddle() {
        return (
            // this will need to return a div with 'dangerouslySetInnerHTML' read from the database
            <React.Fragment>
                <div dangerouslySetInnerHTML={{
                    __html: this.props.BodyHTML
                    }}>
                </div>
                {/* <div style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: '17px' }}>How Say More cards work.</p>
                    <br />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '25%' }}><img src={require("./img/Asset15@2x.png")} style={{ maxHeight: "100%", maxWidth: "100%", width: 'auto', height: 'auto', margin: '0 auto' }} /></div>
                        <div style={{ width: '75%', textAlign: 'left', paddingLeft: '10px' }}>
                            <span className="secondaryColor">Scan your card.</span><br />
                            Use the camera on your phone, or download any QR code scanning app from your app store.
                        </div>
                    </div>
                </div>
                <hr />
                <div style={{ textAlign: 'center' }}>
                    <br />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '75%', textAlign: 'left', paddingLeft: '10px' }}>
                            <span className="secondaryColor">Upload your video.</span><br />
                            Take a live video, or choose one from your device storage. Now when you scan the card again, your video will play.
                        </div>
                        <div style={{ width: '25%' }}><img src={require("./img/scan.png")} style={{ maxHeight: "100%", maxWidth: "100%", width: 'auto', height: 'auto', margin: '0 auto' }} /></div>
                    </div>
                </div>
                <hr />
                <div style={{ textAlign: 'center' }}>
                    <br />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '25%' }}><img src={require("./img/send.png")} style={{ maxHeight: "100%", maxWidth: "100%", width: 'auto', height: 'auto', margin: '0 auto' }} /></div>
                        <div style={{ width: '75%', textAlign: 'left', paddingLeft: '10px' }}>
                            <span className="secondaryColor">Give it away.</span><br />
                            Make someone's day, make any occasion a special one. The thoughtfulness of a paper card meets today's technology; combining two worlds perfectly.
                        </div>
                    </div>
                </div>
                <hr />
                <div style={{ textAlign: 'center' }}>
                    <br />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '33%' }}><img src={require("./img/sale@2x.png")} style={{ maxHeight: "60px", maxWidth: "80%", width: 'auto', height: 'auto', margin: '0 auto' }} /></div>
                        <div style={{ width: '66%', textAlign: 'left' }}><span className="secondaryColor">SPECIAL OFFER</span><br />
                            Buy one card get one free with code #BOGO2018<br /><a className="button" href="https://saymore.net" target="_blank" style={{ maxWidth: '280px' }}>SHOP NOW</a></div>
                    </div>
                </div> */}
            </React.Fragment>
        );
    }
    render() {
        return (
            <div>
                {this.renderCSS()}
                <div className="navbar">
                    <div className="container">

                        <div className="site-title">
                            <div className="logoImage"></div>
                        </div>

                    </div>
                </div>
                <div className="login_register" style={{ height: '100%' }}>
                    <div ref="videoContainer" className="container">
                        <div className="top" style={{ padding: '15px' }}>
                            <div style={{ minWidth: '270px', width: this.state.videoWidth, maxWidth: '100%', height: this.state.videoHeight, maxHeight: this.state.maxVideoHeight, backgroundColor: 'white', padding: '10px', boxShadow: '0 0 10px 1px', margin: '0 auto' }}>
                                <Player
                                    ref="player"
                                    fluid={false}
                                    height="100%"
                                    width="100%"
                                    playsInline
                                    src={this.state.Video.FilePath}
                                    autoplay={true}
                                    poster={this.state.Video.ThumbPath}
                                >
                                    <BigPlayButton position="center" />
                                </Player>
                            </div>
                        </div>
                        <div className="middle" style={{ margin: '0 auto', maxWidth: '450px' }}>
                            {this.renderMiddle()}
                        </div>
                        <hr />
                        <div className="bottom">
                            {/* <a href="https://saymorecards.com" target="_blank"><div className="logoImage"></div></a> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(Share);


// WEBPACK FOOTER //
// ./src/components/Share.js